<div class="preview">
  <main class="preview_content">
    <router-outlet />
  </main>
</div>
